import React from 'react';
import { HeaderFeature } from '@app/src/common/header';
import { FooterFeature } from '@app/src/common/footer';
import { FormRegistry } from '@app/src/common/session';
import { ModalErrorFeature } from '@app/src/common/modalError';

export const Registration: React.FC = () => (
  <React.Fragment>
    <HeaderFeature />
    <FormRegistry />
    <ModalErrorFeature />
    <FooterFeature isDisplay={true} />
  </React.Fragment>
);
